import dayjs from 'dayjs'
// 字体大小
export const FONT_SIZE_LIST = [
  10, 11, 12, 13, 14, 16, 18, 20, 24, 28, 36, 38, 48, 72,
]

// 富文本字体大小
export const RICH_FONT_SIZE_LIST = ['10px', '12px', '16px', '18px', '22px', '32px', '48px']

// 默认提供的空大屏配置
export const EMPTY_SCREEN_TEMPLATE = {
  // 尺寸
  panelProportion: '16:9',
  panelWidth: 1920,
  panelHeight: 1080,
  // 大屏名称
  panelName: '',
  // 配色
  chartColors: 'default', // 全局组件配色
  // 背景颜色  注意回填
  backgroundType: 1, // color 1 || template 2
  background: '#071228', // 背景颜色 or 模版图片链接
  // 交互
  jumpPanelId: '', // 是否自动跳转，记录跳转大屏id
  jumpDelaySecond: undefined, // 延迟多少秒跳转另外一个大屏

  // 大屏内包含的组件
  chartViews: [],

  // 空模版的快照
  panelThumbnail: 'https://oss.qlinyun.com/dev/picture/tYZM3FKbzFmYTamAeh25GdsJsymW4AEm.png',
}

//  大屏背景模板
export const BACKGROUND_TEMPLATE_LIST = [
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background1.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background2.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background3.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background4.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background5.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background6.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background7.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background8.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background9.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background10.png',

]

//  组件边框模板
export const BORDER_TEMPLATE_LIST = [
  'https://oss.qlinyun.com/prod/picture/55wrxNDsrxps3t4c6NwdFrzEEXJ4Yrp5.png',
  'https://kylin-cloud.oss-cn-hangzhou.aliyuncs.com/prod/docx/is-active.svg',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border1.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border4.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border5.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border6.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border7.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border8.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border9.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border10.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border11.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border12.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border13.png',

]
// 默认筛选时间 (六个月前 -> 当前时间)
export const defaultFilterDate = {
  startTime: dayjs().subtract(6, 'month').format('YYYY-MM-') + '01',
  endTime: dayjs().format('YYYY-MM-DD'),
}
